import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss'
})
export class PublicLayoutComponent implements OnInit {
  private isInTelegram = false;

  ngOnInit(): void {
    setTimeout(() => {
      initFlowbite();

      // Check if we're in Telegram mini app
      this.isInTelegram = !!(window?.Telegram?.WebApp && window.Telegram.WebApp.colorScheme);

      if (!this.isInTelegram) {
        // Not in Telegram - use localStorage logic
        this.setupStandardThemeToggle();
      } else {
        // In Telegram - sync UI with Telegram theme but don't override it
        this.setupTelegramThemeToggle();
      }
    }, 100); // Reduced from 500ms to prevent conflicts
  }

  private setupStandardThemeToggle(): void {
    const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
    const themeToggleBtn = document.getElementById('theme-toggle');

    // Function to update icon based on current theme
    const updateIcon = () => {
      const currentIsDark = document.documentElement.classList.contains('dark');
      if (currentIsDark) {
        themeToggleLightIcon?.classList.remove('hidden');
        themeToggleDarkIcon?.classList.add('hidden');
      } else {
        themeToggleDarkIcon?.classList.remove('hidden');
        themeToggleLightIcon?.classList.add('hidden');
      }
    };

    // Set initial icon
    updateIcon();

    // Listen for system theme changes to update icon
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeMediaQuery.addEventListener('change', () => {
      // Only update icon if user hasn't set manual preference
      if (!localStorage.getItem('color-theme')) {
        updateIcon();
      }
    });

    // Handle manual toggle
    themeToggleBtn?.addEventListener('click', () => {
      // toggle icons inside button
      themeToggleDarkIcon?.classList.toggle('hidden');
      themeToggleLightIcon?.classList.toggle('hidden');

      // Toggle theme and save to localStorage
      if (document.documentElement.classList.contains('dark')) {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('color-theme', 'light');
      } else {
        document.documentElement.classList.add('dark');
        localStorage.setItem('color-theme', 'dark');
      }
    });
  }

  private setupTelegramThemeToggle(): void {
    const webApp = window.Telegram?.WebApp;
    const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
    const themeToggleBtn = document.getElementById('theme-toggle');

    // Update icon based on current Telegram theme
    const updateIcon = () => {
      const isDark = webApp?.colorScheme === 'dark';
      if (isDark) {
        themeToggleLightIcon?.classList.remove('hidden');
        themeToggleDarkIcon?.classList.add('hidden');
      } else {
        themeToggleDarkIcon?.classList.remove('hidden');
        themeToggleLightIcon?.classList.add('hidden');
      }
    };

    updateIcon();

    // In Telegram, clicking toggle switches theme and updates Telegram header
    themeToggleBtn?.addEventListener('click', () => {
      const isDark = document.documentElement.classList.contains('dark');

      // Toggle theme
      if (isDark) {
        document.documentElement.classList.remove('dark');
        themeToggleDarkIcon?.classList.remove('hidden');
        themeToggleLightIcon?.classList.add('hidden');
        webApp?.setHeaderColor('#f3f4f6');
      } else {
        document.documentElement.classList.add('dark');
        themeToggleLightIcon?.classList.remove('hidden');
        themeToggleDarkIcon?.classList.add('hidden');
        webApp?.setHeaderColor('#000000');
      }
    });

    // Listen for Telegram theme changes and update icon
    webApp?.onEvent('themeChanged', () => {
      updateIcon();
    });
  }
}
